// extracted by mini-css-extract-plugin
export default {"designer-container":"designer_designer-container__TxYPE"};